import { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getEmployee, resetAllOptions } from "../../../../../redux/actions/handbookAction";
import { getDealNumber } from "../../../../../redux/actions/clientsAction";
import { initialData } from "../utils";
import { DEFAULT_VALUES } from "../constants";

const useServiceInformation = ({ setValue, tempEntity, clientId }) => {
  const dispatch = useDispatch();
  const { users } = useSelector(({ handbook }) => handbook);
  
  const [descriptions, setDescriptions] = useState(DEFAULT_VALUES.descriptions);
  const [employees, setEmployees] = useState(DEFAULT_VALUES.employees);
  
  const employeesValue = useMemo(() => employees, [employees]);

  const fetchEmployees = useCallback(
    (searchTerm) => {
      if (searchTerm.length >= 2) {
        dispatch(
          getEmployee({ bySearch: searchTerm, document: true, active: "active=true" })
        );
      }
    },
    [dispatch]
  );

  const handleGetDealNumber = useCallback(
    (dealNumber) => {
      if (!clientId) return;

      const params = {
        size: 5,
        page: 1,
        descending: false,
        sortBy: "dealNumber",
        number: dealNumber,
        filters: {
          clientIds: clientId,
        },
      };

      dispatch(getDealNumber(params));
    },
    [dispatch]
  );

  useEffect(() => {
    const formattedEmployees = users.map((u) => ({
      value: u.fullName,
      label: u.fullName,
    }));
    setEmployees(formattedEmployees);
  }, [users]);

  useEffect(() => {
    if (!tempEntity) return;

    const setEntityValues = (key, list) => {
      setValue(key, initialData(list));
    };

    setEntityValues('furtherActions', tempEntity.furtherActions);
    setEntityValues('blockTransactions', tempEntity.blockTransactions);
    const suspiciousTransactions = tempEntity.suspiciousTransactions;
    if (suspiciousTransactions?.length) {
      suspiciousTransactions.forEach((transaction, index) => {
        const list = transaction.financeSuspiciousOperations.length ? transaction.financeSuspiciousOperations : [DEFAULT_VALUES.dealOperation]
        setValue(`suspiciousTransactions.${index}.financeSuspiciousOperations`, initialData(list));
      });
    }
    setValue("riskFinal", tempEntity.riskFinal || 'Низкий');
  }, [tempEntity, setValue]);

  useEffect(() => {
    return () => {
      dispatch(resetAllOptions());
    };
  }, [dispatch]);

  return {
    descriptions,
    employees: employeesValue,
    setDescriptions,
    fetchEmployees,
    handleGetDealNumber,
  };
};

export default useServiceInformation;
